// extracted by mini-css-extract-plugin
export default {"gradient-bg5":"eventsDisplay__gradient-bg5__eOdwa"};